import {Component} from 'preact'
import {connect} from 'preact-redux'
import _ from 'lodash'
import style from './style.scss'

import SystemModel from '/chat/src/redux/model/system/model';
import FeaturesModel from '/chat/src/redux/model/features/model';
import CustomizationModel from '/chat/src/redux/model/customization/model';

import TextDisplay from '/chat/src/components/TextDisplay'
import Feedback from './Feedback/Feedback'

import DateTime from '/chat/src/lib/DateTime';

const REQUEST_STATES = {
    LOADING: 'loading',
    FAIL: 'fail',
    SUCCESS: 'success'
}

class HelpDeskArticle extends Component {
    constructor(props) {
        super(props)
        this._goBack = this._goBack.bind(this)
        this._handleRequest = this._handleRequest.bind(this)

        this.state = {
            xTranslation: -5,
            opacity: 0,
            requestState: REQUEST_STATES.LOADING,
            articleTitle: '',
            articleContent: '',
            authorImg: '',
            authorName: '',
            dateModified: '',
        }
    }

    _handleRequest(payload, status) {
        if (status !== '200') {
            this.setState({requestState: REQUEST_STATES.FAIL})
        } else {
            const { question, answer, author_img, author_name, date_modified } = payload.faq

            this.setState({
                articleContent: answer,
                articleTitle: question,
                authorImg: author_img,
                authorName: author_name,
                dateModified: date_modified,
                requestState: REQUEST_STATES.SUCCESS,
            })
            setTimeout( () => this.setState({xTranslation: 0, opacity: 1}), 0 )
        }
    }

    componentDidMount() {
        this.setState({requestState: REQUEST_STATES.LOADING});
        FeaturesModel.requestFAQArticle(this.props.articleId, this._handleRequest);
    }

    _renderText() {
        return (
            <div className={style.ArticleTextContainer}>
                <div className={style.Title}> {this.state.articleTitle} </div>
                <div className={style.BodyText}>
                    <TextDisplay text={this.state.articleContent}/>
                </div>
            </div>
        )
    }

    _renderProfile() {
        const { authorName, authorImg, dateModified} = this.state;
        const niceDate = DateTime.getDetailedNiceDate(dateModified);
        let placeholder = false;

        if(authorImg === '/images/employee-avatar.png'){
            placeholder = true;
        }

        return (
            <div>
                {(authorImg && !placeholder) && <img className={style.ProfilePicture}
                src={this.state.authorImg}/>}
                <div className={style.ProfileMetaText}>
                    {(authorName) && <div> Skriven av: {authorName} </div>}
                    <div> Uppdaterad: {niceDate} </div>
                </div>
            </div>
        )
    }

    _goBack() {
        const activeCategory =  this.props.activeCategory
        if (activeCategory === '-1') {
            this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDeskSearch'))
        } else {
            this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDeskFocused', activeCategory))
        }
    }

    render() {
        const {xTranslation, opacity, requestState, dateModified} = this.state;
        const {language, articleId} = this.props

        if (requestState === REQUEST_STATES.LOADING) return null;

        let article = '';
        switch(requestState) {
            case REQUEST_STATES.FAIL:
                article = <div className = {style.ErrorText}> {language.get('ArticleFetchError')} </div>
                break;
            default:
                article = <div className={style.ArticleContainer} style={{transform: `translateX(${xTranslation}px)`, opacity: opacity}}>
                    {this._renderText()}
                    {this._renderProfile()}
                    <div className={style.BackLink} onClick={this._goBack}>
                         {`< ${language.get('BackButton')}`}
                    </div>
                </div>
                break;
        }

        return (
            <div className={style.ArticlePage} style={{height: `${this.props.height}px`}}>
                {article}
                {requestState !== REQUEST_STATES.FAIL ? <Feedback articleId={articleId} dateModified={dateModified}/> : null}
            </div>
        )
    }
}

function mapStateToProps(state)
{
    const fullRoute = SystemModel.getHelpDeskRoute(state).split(';')
    const articleId = fullRoute[2];
    const activeCategory = fullRoute[1];
    return {
        height: SystemModel.getBodyHeight(state),
        activeCategory: activeCategory,
        articleId: articleId,
        language: CustomizationModel.getLanguage(state)
    };
}


export default connect(mapStateToProps)(HelpDeskArticle)



// WEBPACK FOOTER //
// ./routes/HelpDesk/HelpDeskArticle/HelpDeskArticle.js